//css
import { Link } from "react-router-dom";
import styled from "styled-components";

//img
import CheckIcon from "../../assets/img/icon/icon_check_only.svg";
// responsive
import { M, MMinus, T } from "../../utils/MT";

export default function CheckBox(props) {
    return (
        <>
            {props.withText ? (
                <>
                    <ChkInput active={props.active} type="checkbox" id={props.id} />
                    <ChkLabel htmlFor={props.id}>
                        <ChkImg></ChkImg>
                        <ChkText>{props.text}</ChkText>
                        <ChkOption gray={props.gray}>{props.option}</ChkOption>
                    </ChkLabel>
                </>
            ) : (
                <>
                    <ChkInput type="checkbox" id={props.id} />
                    <ChkLabel htmlFor={props.id}>
                        <ChkImg></ChkImg>
                        <ChkText>
                            <b>{props.text}</b>
                        </ChkText>
                    </ChkLabel>
                </>
            )}
        </>
    );
}

const ChkInput = styled.input`
    display: none;

    &:checked + label span:first-child {
        background: var(--main-color);
    }

    &:not(:first-child) {
        padding-left: calc(100vw * (27 / 1920));
    }

    &:checked + label span:first-child:after {
        height: calc(100vw * (7 / 1920));
    }

    &:checked + label span:first-child:before {
        height: calc(100vw * (11 / 1920));
        transition-delay: 0;
    }

    ${({ active }) => {
        return (
            active &&
            `
        &:checked + label span {
            color: var(--main-color);
        }
        `
        );
    }}

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            padding-left: calc(100vw * (27 / 1300));
        }

        &:checked + label span:first-child:after {
            height: calc(100vw * (7 / 1300));
        }

        &:checked + label span:first-child:before {
            height: calc(100vw * (11 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:first-child) {
            padding-left: ${M(27)};
        }

        &:checked + label span:first-child:after {
            height: ${M(7)};
        }

        &:checked + label span:first-child:before {
            height: ${M(11)};
        }
    }
`;

const ChkLabel = styled.label`
    display: flex;
    align-items: center;
`;

const ChkImg = styled.span`
    flex-shrink: 0;
    position: relative;
    display: inline-block;
    width: calc(100vw * (20 / 1920));
    height: calc(100vw * (20 / 1920));

    margin-right: calc(100vw * (10 / 1920));

    border-radius: 4px;
    border: 1px solid var(--main-color);
    background-color: #fff;

    &:after,
    &:before {
        position: absolute;
        content: "";

        width: calc(100vw * (3 / 1920));
        height: 0;

        background-color: #fff;
        transform-origin: left top;
    }

    &:after {
        top: 45%;
        left: 12%;

        transform: rotate(-45deg);
        border-radius: 4px 4px 0 0;
        transition: height 0.2s ease;
    }
    &:before {
        top: 76%;
        left: 44%;

        transform: rotate(-135deg);
        border-radius: 4px;
        transition: height 0.2s ease 0.2s;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (20 / 1300));
        height: calc(100vw * (20 / 1300));

        margin-right: calc(100vw * (10 / 1300));

        &:after,
        &:before {
            width: calc(100vw * (3 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(20)};
        height: ${M(20)};

        margin-right: ${M(5)};

        &:after,
        &:before {
            width: ${M(2)};
        }
    }
`;

const ChkText = styled.span`
    font-size: calc(100vw * (14 / 1920));
    color: #222222;

    ${({ bold }) => {
        return bold && `color:#FAAA00;`;
    }}

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: calc(100vw * (14 / 428));
        margin-left: calc(100vw * (10 / 428));
    }
`;
const ChkOption = styled.span`
    font-size: calc(100vw * (14 / 1920));
    color: var(--main-color);
    margin-left: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
        margin-left: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-left: ${M(10)};
    }

    ${({ option }) => {
        return option ? `color: #AAAAAA;` : `color: var(--main-color);`;
    }}

    ${({ gray }) => {
        return gray && `color:#AAAAAA;`;
    }}
`;
